import Model from './Model'
export default class OfferProduct extends Model {

    resource()
    {
        return 'offer-products'
    }

    get measurements() {
        return [{
            value: 'BUC',
            text: 'BUC'
        }, {
            value: 'LITRU',
            text: 'LITRU'
        }, {
            value: 'KG',
            text: 'KG'
        }, {
            value: 'ML',
            text: 'ML'
        }, {
            value: 'ORA',
            text: 'ORA'
        }, {
            value: 'KM',
            text: 'KM'
        }]
    }
}
